(() => {
  const selector = '[data-kas-checkout]';
  const root = window.Shopify?.routes?.root || '/';
  let checkoutPending = false;
  let originButton = null;
  let continueToCheckout = false;
  let dialog;
  const keys = ['Fatura Tipi', 'Firma Unvanı', 'Vergi Dairesi', 'Vergi Numarası', 'T.C. Kimlik Numarası'];

  function termsAccepted(button) {
    const container = button.closest('[data-kas-payment-choice]');
    if (container?.dataset.kasTermsRequired !== 'true') return true;
    const scope = button.closest('.m-cart__checkout, .m-cart-drawer__footer') || document;
    const checkbox = scope.querySelector('input[name="agree_terms"]');
    return !checkbox || checkbox.checked;
  }

  function createDialog() {
    if (dialog) return;
    const style = document.createElement('style');
    style.textContent = `
      #kas-invoice-dialog{border:0;border-radius:18px;padding:0;width:calc(100% - 32px);max-width:520px;max-height:90dvh;overflow:auto;color:#242424;background:#fff;box-shadow:0 24px 80px #0003;margin:auto}
      #kas-invoice-dialog::backdrop{background:#0008}
      #kas-invoice-dialog form{padding:26px;display:grid;gap:16px}
      #kas-invoice-dialog header{display:flex;align-items:center;justify-content:space-between;gap:16px}
      #kas-invoice-dialog h2{font-size:23px;font-weight:700;margin:0}
      #kas-invoice-dialog p{font-size:14px;line-height:1.5;margin:0;color:#616161}
      #kas-invoice-dialog label{display:grid;gap:6px;font-size:14px;font-weight:600}
      #kas-invoice-dialog input,#kas-invoice-dialog select{width:100%;font:inherit;font-size:16px;border:1px solid #ccc;border-radius:8px;padding:11px;background:#fff;color:#242424}
      #kas-invoice-dialog [hidden]{display:none!important}
      #kas-invoice-dialog .kas-invoice-company{display:grid;gap:14px}
      #kas-invoice-dialog button{cursor:pointer}
      #kas-invoice-dialog .kas-invoice-close{border:0;background:transparent;padding:4px 10px;font-size:26px;line-height:1}
      #kas-invoice-dialog .kas-invoice-submit{border:0;border-radius:9px;background:#ef7929;color:#fff;font-weight:700;padding:14px;font-size:16px}
      #kas-invoice-dialog button:disabled{opacity:.6;cursor:wait}
      #kas-invoice-dialog [role=alert]{color:#b42318}
      .kas-invoice-edit{display:block;width:100%;padding:10px;margin:0 0 10px;border:1px solid #e0b18e;border-radius:8px;background:#fff8f2;color:#77401e;font-size:14px;font-weight:600;cursor:pointer}
      @media(max-width:480px){#kas-invoice-dialog form{padding:20px}}
    `;
    document.head.append(style);
    dialog = document.createElement('dialog');
    dialog.id = 'kas-invoice-dialog';
    dialog.setAttribute('aria-labelledby', 'kas-invoice-title');
    dialog.innerHTML = `
      <form>
        <header><h2 id="kas-invoice-title">Fatura Bilgileri</h2><button type="button" class="kas-invoice-close" aria-label="Kapat">×</button></header>
        <p>Fatura türünü seçin. Fatura adresinizi bir sonraki adımda, ödeme ekranında girebilirsiniz.</p>
        <label>Fatura türü<select name="invoiceType"><option value="Bireysel">Bireysel fatura</option><option value="Kurumsal">Kurumsal fatura</option></select></label>
        <div class="kas-invoice-company" hidden>
          <label>Firma unvanı *<input name="company" autocomplete="organization" maxlength="200"></label>
          <label>Vergi dairesi *<input name="taxOffice" maxlength="100"></label>
          <label>Vergi numarası / T.C. kimlik numarası *<input name="taxNumber" inputmode="numeric" pattern="[0-9]{10,11}" minlength="10" maxlength="11" title="10 haneli vergi numarası veya 11 haneli T.C. kimlik numarası girin."></label>
        </div>
        <label class="kas-invoice-person">T.C. kimlik numarası (isteğe bağlı)<input name="identity" inputmode="numeric" pattern="[0-9]{11}" minlength="11" maxlength="11" title="11 haneli T.C. kimlik numarası girin."></label>
        <p>Girdiğiniz bilgiler, faturalama için siparişinizle birlikte kaydedilir.</p>
        <p role="alert" hidden></p>
        <button type="submit" class="kas-invoice-submit">Kaydet ve ödemeye devam et</button>
      </form>`;
    document.body.append(dialog);
    dialog.querySelector('.kas-invoice-close').addEventListener('click', () => dialog.close());
    dialog.querySelector('select').addEventListener('change', updateFields);
    dialog.querySelector('form').addEventListener('submit', saveInvoice);
    dialog.addEventListener('close', () => { if (!checkoutPending) originButton?.focus(); });
  }

  function updateFields() {
    const company = dialog.querySelector('select').value === 'Kurumsal';
    dialog.querySelector('.kas-invoice-company').hidden = !company;
    dialog.querySelector('.kas-invoice-person').hidden = company;
    dialog.querySelectorAll('.kas-invoice-company input').forEach(input => {
      input.disabled = !company;
      input.required = company;
    });
    dialog.querySelector('[name=identity]').disabled = company;
  }

  async function openInvoice(button, checkout) {
    if (checkoutPending || dialog?.open) return;
    if (checkout && !termsAccepted(button)) {
      const scope = button.closest('.m-cart__checkout, .m-cart-drawer__footer') || document;
      scope.querySelector('input[name="agree_terms"]')?.focus();
      return;
    }
    createDialog();
    originButton = button;
    continueToCheckout = checkout;
    const form = dialog.querySelector('form');
    form.reset();
    updateFields();
    const error = dialog.querySelector('[role=alert]');
    error.hidden = true;
    const submit = dialog.querySelector('[type=submit]');
    submit.textContent = checkout ? 'Kaydet ve ödemeye devam et' : 'Fatura bilgilerini kaydet';
    submit.disabled = true;
    dialog.showModal();
    try {
      const response = await fetch(root + 'cart.js', {headers: {Accept:'application/json'}, cache:'no-store'});
      if (!response.ok) throw new Error();
      const cart = await response.json();
      const attributes = cart.attributes || {};
      form.elements.invoiceType.value = attributes[keys[0]] === 'Kurumsal' ? 'Kurumsal' : 'Bireysel';
      form.elements.company.value = attributes[keys[1]] || '';
      form.elements.taxOffice.value = attributes[keys[2]] || '';
      form.elements.taxNumber.value = attributes[keys[3]] || '';
      form.elements.identity.value = attributes[keys[4]] || '';
      updateFields();
      submit.disabled = false;
    } catch (_error) {
      error.textContent = 'Fatura bilgileri yüklenemedi. Pencereyi kapatıp tekrar deneyin.';
      error.hidden = false;
    }
  }

  async function saveInvoice(event) {
    event.preventDefault();
    if (checkoutPending) return;
    const form = event.currentTarget;
    const corporate = form.elements.invoiceType.value === 'Kurumsal';
    if (!form.reportValidity()) return;
    const attributes = {
      [keys[0]]: corporate ? 'Kurumsal' : 'Bireysel',
      [keys[1]]: corporate ? form.elements.company.value.trim() : '',
      [keys[2]]: corporate ? form.elements.taxOffice.value.trim() : '',
      [keys[3]]: corporate ? form.elements.taxNumber.value.trim() : '',
      [keys[4]]: corporate ? '' : form.elements.identity.value.trim()
    };
    if (corporate && (!attributes[keys[1]] || !attributes[keys[2]])) {
      const error = dialog.querySelector('[role=alert]');
      error.textContent = 'Firma unvanını ve vergi dairesini girin.';
      error.hidden = false;
      return;
    }
    if (continueToCheckout) attributes.havale_indirimi = originButton.dataset.kasCheckout === 'bank' ? 'true' : '';
    const submit = form.querySelector('[type=submit]');
    checkoutPending = true;
    submit.disabled = true;
    submit.textContent = 'Kaydediliyor…';
    dialog.querySelector('[role=alert]').hidden = true;
    try {
      const response = await fetch(root + 'cart/update.js', {
        method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({attributes})
      });
      if (!response.ok) throw new Error();
      const saved = await response.json();
      if (Object.entries(attributes).some(([key,value]) => value && saved.attributes?.[key] !== value)) throw new Error();
      if (continueToCheckout) window.location.assign(root + 'checkout');
      else { checkoutPending = false; dialog.close(); }
    } catch (_error) {
      checkoutPending = false;
      const error = form.querySelector('[role=alert]');
      error.textContent = 'Bilgiler kaydedilemedi. Lütfen tekrar deneyin.';
      error.hidden = false;
    } finally {
      if (!checkoutPending) {
        submit.disabled = false;
        submit.textContent = continueToCheckout ? 'Kaydet ve ödemeye devam et' : 'Fatura bilgilerini kaydet';
      }
    }
  }

  document.addEventListener('click', event => {
    const button = event.target.closest(selector + ', .kas-invoice-edit');
    if (!button) return;
    event.preventDefault();
    openInvoice(button, button.matches(selector));
  });

  document.addEventListener('change', event => {
    if (!event.target.matches('input[name="agree_terms"]')) return;
    const scope = event.target.closest('.m-cart__checkout, .m-cart-drawer__footer') || document;
    scope.querySelectorAll(selector).forEach(button => { button.disabled = !event.target.checked; });
  });

  function mountButtons() {
    document.querySelectorAll('[data-kas-payment-choice]').forEach(container => {
      if (container.previousElementSibling?.classList.contains('kas-invoice-edit')) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'kas-invoice-edit';
      button.textContent = 'Fatura bilgilerini gir / düzenle';
      container.before(button);
    });
  }
  function init() {
    createDialog();
    mountButtons();
    const observer = new MutationObserver(mountButtons);
    observer.observe(document.body, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
